import React from 'react';
import PropTypes from 'prop-types';
import FieldPropertyForm from "./Forms/FieldPropertyForm";

export default function FieldProperties(props) {
  return (
    <div className={'height-100'}>
      <FieldPropertyForm formType={'field'} />
    </div>
  )
}

FieldProperties.propTypes = {
  text: PropTypes.string,
};
